import React from "react";
import ReactDOM from "react-dom/client";
// Use full router from routes.tsx (with auth, init, etc.)
import { AppRouter } from "./routes.tsx";
import "./index.css";
import { initializeGraphQL } from "./graphqlInit";
// i18n - must be imported before render
import "./i18n";
// Log collector for client-side error capture
import { initLogCollector, getStoredUser } from "@business-assistant/shared";
// Tenant context for multi-tenant support
import { TenantProvider, getTenantFromSubdomain } from "@business-assistant/shared/context/tenantContext.tsx";

console.log('[main.tsx] Circular dependencies fixed - loading full app');

// Detect tenant from subdomain (for multi-tenant routing)
const tenantInfo = getTenantFromSubdomain();
if (tenantInfo.isTenantSubdomain) {
  console.log('[main.tsx] Tenant detected:', tenantInfo.slug);
} else if (tenantInfo.isMainApp) {
  console.log('[main.tsx] Main app (no tenant subdomain)');
}

initializeGraphQL();

// Initialize log collector after GraphQL is ready
// It will start capturing errors once a user is logged in
initLogCollector(
  () => {
    const user = getStoredUser();
    return user?.id ?? null;
  },
  () => {
    // TODO: Return actual account ID from tenant context when available
    // For now, use user ID as account ID (single-account users)
    // Backend can implement proper multi-tenant filtering
    const user = getStoredUser();
    return user?.id ?? null;
  }
);

const root = document.getElementById("root") as HTMLElement;

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <TenantProvider>
      <AppRouter />
    </TenantProvider>
  </React.StrictMode>
);
